import { BaseBuildPart } from './../base-build-part';
import { HelperParams } from './../helper-params';
import { SampleTrackerData, StudyGroupInfo } from '../../../sample-tracking/group-info/study-group-info';
import { StudyGroupDashboardBuildPart } from './study-group-dashboard-build-part';
import { ProtocolDashboardBuildPart } from './protocol-dashboard-build-part';
import { SampleTrackingReportBuildPart } from './sample-tracking-report-build-part';
import { SampleMonitoringBuildPart } from './sample-monitoring-build-part';

export class SampleTrackingBuildPart extends BaseBuildPart {
    constructor(
        private readonly sampleTrackingHelperParams: HelperParams,
        parent: BaseBuildPart
    ) {
        super(sampleTrackingHelperParams, parent, ['sampletracking']);
    }

    public home(): BaseBuildPart {
        return new BaseBuildPart(this.sampleTrackingHelperParams, this, ['home']);
    }

    public sampleAliquots(): BaseBuildPart {
        return new BaseBuildPart(this.sampleTrackingHelperParams, this, ['samples']);
    }

    public sampleMonitoring(): SampleMonitoringBuildPart {
        return new SampleMonitoringBuildPart(this.sampleTrackingHelperParams, this);
    }

    public report(): SampleTrackingReportBuildPart {
        return new SampleTrackingReportBuildPart(this.sampleTrackingHelperParams, this);
    }

    public preference(): BaseBuildPart {
        return new BaseBuildPart(this.sampleTrackingHelperParams, this, ['preference']);
    }

    public studyGroup(studyGroup: StudyGroupInfo): StudyGroupDashboardBuildPart {
        return new StudyGroupDashboardBuildPart(this.sampleTrackingHelperParams, this, studyGroup);
    }

    public protocolInfo(protocolInfo: SampleTrackerData): ProtocolDashboardBuildPart {
        return new ProtocolDashboardBuildPart(this.sampleTrackingHelperParams, this, protocolInfo);
    }

    public visitDetails(): BaseBuildPart {
        return new BaseBuildPart(this.sampleTrackingHelperParams, this, ['tracking', 'visit']);
    }

    public sampleDetails(containerNo: number): BaseBuildPart {
        return new BaseBuildPart(this.sampleTrackingHelperParams, this, ['tracking', 'sample', containerNo]);
    }

    public subjectSearchResults(subjectID: string): BaseBuildPart {
        return new BaseBuildPart(this.sampleTrackingHelperParams, this, ['subject', subjectID, 'search']);
    }

    public subjectVisitDetails(subjectID: string): BaseBuildPart {
        return new BaseBuildPart(this.sampleTrackingHelperParams, this, ['subject', subjectID, 'visit', 'list']);
    }

    public subjectSampleDetails(subjectID: string): BaseBuildPart {
        return new BaseBuildPart(this.sampleTrackingHelperParams, this, ['subject', subjectID, 'samples', 'list']);
    }
}